import React from 'react';
import { Button } from 'reactstrap'

const ErrorModal = ({ text, onCancelError }) => {
  return (
    <div style={{
      background: 'white', 
      width: 'fit-content', 
      padding: '35px', 
      height: 'auto', 
      margin: '25% auto', 
      borderRadius: '10px', 
      position: 'relative'
    }}>
      <h3>Error</h3>
      <pre>{text}</pre>
      <br />
      <Button color="danger" size='sm' onClick={onCancelError}>OK</Button>
    </div>
  );
}

export default ErrorModal;